import { ChangeDetectionStrategy, Component, Input, input, OnInit } from '@angular/core';
import { ComponentStatus, StateComponent } from '../../../../../../../components/state/state.component';
import { IFormBettings, IFormConfig, IPlayoffBetting, IPlayoffStageFormConfig, ITeamLookupDto, ITeamsMetadata, UnderOver } from '@oogaday/shared';
import { UntypedFormGroup } from '@angular/forms';
import { IBettingOption, IDropdownConfig } from '../common/model/betting.model';
import { UtilsService } from '../../../../../../../services/utils.service';
import { OptionsProviderService } from '../common/services/options-provider.service';
import { ButtonGroupBettingComponent } from '../common/components/button-group-betting/button-group-betting.component';
import { DropdownsBettingComponent } from '../common/components/dropdowns-betting/dropdowns-betting.component';
import { MatCard, MatCardContent, MatCardHeader, MatCardSubtitle, MatCardTitle } from '@angular/material/card';


@Component({
  selector: 'oo-playoff-form-filler',
  templateUrl: './playoff-form-filler.component.html',
  styleUrls: ['./playoff-form-filler.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatCard, MatCardHeader, MatCardTitle, MatCardSubtitle, MatCardContent, DropdownsBettingComponent, ButtonGroupBettingComponent],
})
export class PlayoffFormFillerComponent extends StateComponent<PlayoffFormFillerComponentState> implements OnInit {


  readonly metadata = input.required<ITeamsMetadata>();
  state: PlayoffFormFillerComponentState = {
    status: 'ready',
    config: null!,
    duels: [],
    betting: undefined,
    bettingForm: null!,
    isSubmissionMode: false,
    qualifiersOptions: [],
    underOverOptions: [],
  };


  @Input() set config(config: IFormConfig) {
    this.updateState({ config: config as IPlayoffStageFormConfig });
  }

  @Input() set bettingForm(bettingForm: UntypedFormGroup) {
    this.updateState({ bettingForm });
  }

  @Input() set betting(betting: IFormBettings<any> | undefined) {
    this.updateState({ betting });
  }

  @Input() set isSubmissionMode(isSubmissionMode: boolean) {
    this.updateState({ isSubmissionMode });
  }

  ngOnInit(): void {
    this.setDuels();

    this.updateState({
      qualifiersOptions: this.optionsPerDuel(this.state.duels),
      underOverOptions: OptionsProviderService.getUnderOverOptions(this.state.duels.length * 2 * 2.5),
    });
  }

  private setDuels(): void {
    const teamsMap = UtilsService.listToMap(this.metadata().teams, 'id');

    this.updateState({
      duels: this.state.config.duels
        .map((teams) => teams.map(teamId => teamsMap.get(teamId)!)) as [ITeamLookupDto, ITeamLookupDto][],
    });
  }

  private optionsPerDuel(duels: ITeamLookupDto[][]): IDropdownConfig[] {
    return duels
      .map((duel, i) => ({
          label: `Duel ${i + 1}`,
          options: duel.map((team) => ({
            value: team.id,
            name: team.name,
            subtitle: this.state.config.betsConfig.qualifiers.odds[team.id] ?
              ` (${this.state.config.betsConfig.qualifiers.odds[team.id]})` : '',
          })),
        }),
      );
  }
}

interface PlayoffFormFillerComponentState {
  status: ComponentStatus;
  config: IPlayoffStageFormConfig;
  duels: [ITeamLookupDto, ITeamLookupDto][];
  betting: IPlayoffBetting | undefined;
  bettingForm: UntypedFormGroup;
  isSubmissionMode: boolean;
  qualifiersOptions: IDropdownConfig[];
  underOverOptions: IBettingOption<UnderOver>[];
}
